import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { PaymentService } from 'src/app/services/shipment-payment.service';

@Component({
  selector: 'app-payment-result',
  templateUrl: './payment-result.page.html',
  styleUrls: ['./payment-result.page.scss'],
})
export class PaymentResultPage implements OnInit {

  orderId: string | null = null;
  chatId: string | null = null;
  isLoading = true;
  paymentStatus: string = '';
  paymentMessage: string = '';
  paymentSuccessMsg: boolean;

  //   message = '';
  // isSuccess = false;

  constructor(
    private route: ActivatedRoute, 
    private paymentService: PaymentService,
    protected translate: TranslateService
  ) {}

  async ngOnInit() {

    this.orderId = this.route.snapshot.queryParamMap.get('order_id');
    this.chatId = this.route.snapshot.queryParamMap.get('chat_id');

    // if (!this.orderId) {
    //   this.message = '❌ Invalid or missing payment reference.';
    //   this.paymentMessage = '❌ Invalid or missing payment reference.';
    //   this.isSuccess = false;
    //   this.isLoading = false;
    //   return;
    // }
    // try {
    //   // Call API to save/capture payment
    //   const result = await firstValueFrom(this.paymentService.capturePayment(this.orderId));

    //   // Use the message from backend
    //   if (result?.status === 'success') {
    //     this.message = result.message || '✅ Payment saved successfully!';
    //     this.isSuccess = true;
    //   } else {
    //     this.message = '⚠️ Payment failed or incomplete.';
    //     this.isSuccess = false;
    //   }
    // } catch (error) {
    //   console.error('Error capturing payment:', error);
    //   this.message = '❌ An error occurred while processing your payment.';
    //   this.isSuccess = false;
    // } finally {
    //   this.isLoading = false;
    // }


    console.log("this.orderId", this.orderId);
    if (this.orderId) {
      // this.paymentStatus = "Payment Captured"
      // try {
      //   const result = await firstValueFrom(this.paymentService.capturePayment(this.orderId));
      //   this.paymentStatus = result?.status;
      //   this.paymentmessage = result?.message;
      //   console.log("result", result)
      //   // Handle result (e.g., 'paid', 'pending', 'failed')
      // } catch (error) {
      //   console.error('Error capturing payment:', error);
      //   this.paymentStatus = 'failed';
      // } finally {
      //   this.isLoading = false;
      // }




    this.paymentService.capturePayment(this.orderId).subscribe({
     next: (res) => {
        console.log({res});
        this.paymentStatus = res?.payment_status;

        if (this.paymentStatus === 'open') {
          this.paymentMessage = this.translate.instant('MolliPayment.open');
        }

        if (this.paymentStatus === 'paid') {
          this.paymentMessage = this.translate.instant('MolliPayment.paid');
        }

        if (!['paid', 'open'].includes(this.paymentStatus)) {
          this.paymentMessage = this.translate.instant('MolliPayment.failed');
        }

        this.isLoading = false;
      },
      error: (err) => {
        this.paymentMessage = this.translate.instant('MolliPayment.error');
        this.paymentStatus = 'failed';
        this.isLoading = false;
        console.error(err);
      }

    });
    } else {
      this.paymentStatus = 'invalid';
      this.isLoading = false;
    }
  }
}
